import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {ApplyStatus} from '../models/apply-status';
import 'rxjs/add/operator/map';

@Injectable()
export class ApplyStatusService {

  private applyStatusUrl: string = `${ environment.apiRoot }/apply-status/`;

  constructor(private http: HttpAuth) { }

  public getApplyStatus3(): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });
    return this.http.get(this.applyStatusUrl)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getApplyStatus(): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    const params: URLSearchParams = new URLSearchParams();
      params.set('list', '2');
      const options = new RequestOptions({search: params});
    return this.http.get(this.applyStatusUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getApplyStatusList(page?: number, pagecount?: number, query?: string, list?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '5');
    }

    if (query) {
        params.set('query', query);
    }

    if (list) {
      params.set('list', String(list));
    } else {
      params.set('list', '1');
    }
    const options = new RequestOptions({search: params});

    return this.http.get(this.applyStatusUrl, options)
    // return this.http.get(this.applyStatusUrl+"?list=1", options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putApplyStatus(applyStatus:ApplyStatus): Observable<ApplyStatus> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.put(this.applyStatusUrl,applyStatus,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postApplyStatus(applyStatus:ApplyStatus): Observable<ApplyStatus> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(this.applyStatusUrl,applyStatus,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public deleteApplyStatus(applyStatusID): Observable<ApplyStatus> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey,
      'id': applyStatusID
    });

    return this.http.delete(this.applyStatusUrl+"?id="+applyStatusID,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/apply-status.service.ts